import React, { useEffect, useState } from 'react';
import { submitEmergencyEnds } from '../../services/dashboardService';
import { useNavigate } from "react-router-dom";

export default function ProcessModal({ data, onClose, onCancel, initialSelectedAlertId }) {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  // ✅ 초기 선택
  useEffect(() => {
    if (!data.length) return;
    if (initialSelectedAlertId) {
      const match = data.find(d => String(d.alert_id) === String(initialSelectedAlertId));
      setSelected(match || data[0]);
    } else {
      setSelected(data[0]);
    }
  }, [initialSelectedAlertId, data]);

 const handleEnd = async (item) => {
  const token = localStorage.getItem("token");
  try {
    const res = await submitEmergencyEnds(token);
    if (res.success) {
      alert("상황 종료 처리 완료");
      onClose();
    } else {
      alert("상황 종료 처리 실패");
    }
  } catch (err) {
    console.error("❌ API 호출 에러:", err);
  }
};

const handleGoToUserAlert = (item) => {
    if (!item) return;
    navigate(`/user/${item.id}`, { state: { report_id: item.report_id,  defaultTab: "alert" } });
    onClose(); // 모달 닫기
  };


  return (
    <>
      <div className='modalbg'></div>
      <div className="modal table processmodal">
        <h3>상황종료</h3>
        <div className='table2'>
          <table>
            <thead>
              <tr>
                <th>이름</th>
                <th>주소</th>
                <th>나이</th>
                <th>성별</th>
                <th>지병</th>
                <th>발생시간</th>
                <th>종료 담당 부서</th>
                <th>응급상황 현황</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
 data.map((item, idx) => {
  const gender = item.gender || item.sex || '-';
  const status = item.status || item.pec || '-';
  return (
    <tr key={idx}>
      <td>{item.name || '-'}</td>
      <td>{item.address || '-'}</td>
      <td>{item.age || '-'}</td>
      <td>{gender}</td>
      <td>{status}</td>
      <td>{item.create_date || '-'}</td>
      <td>{item.closed_department || '-'}</td>
      <td className='btntd'>
        <button onClick={() => handleGoToUserAlert(item)}>응급상황 작성</button>
      </td>
    </tr>
  );
}) ): (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}>데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="btn-group">
          <button onClick={onClose} className='btncolor01'>확인</button>
        </div>
      </div>
    </>
  );
}
